import React from "react";

const ModalOverlay = props => {
  return (
    <div className={`${props.show ? "active loading-modal" : ""}`}>
      <div className="white-bg">{/* White frosty background */}</div>
      <div className="modal">
        {/* Loading animation */}

        <div
          className={
            props.complete ? "circle-loader load-complete" : "circle-loader"
          }
        >
          <div className={props.complete ? "checkmark draw show" : "hide"} />
        </div>
        <div id="modal-message">{props.message}</div>
      </div>
    </div>
  );
};

export default ModalOverlay;



// WEBPACK FOOTER //
// ./src/components/modal/modal.component.js